import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import { InputDate } from "../../input-date";

export const DateFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <InputDate
      tipo={campo.tipo as "date" | "datetime-local"}
      campo={campo}
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      modo={modo}
      apenasLeitura={campo.apenasLeitura || false}
      onBlur={() => handleBlur(campo)}
      hasError={!!errors[campo.nome]}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
